import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  Text,
} from '@chakra-ui/react';
import { Link, graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import { generate } from 'shortid';
import FlareGroup7 from '../assets/shapes/shape-group-7.svg';

import {
  HalfByHalfSection,
  CalloutPhoneNumber,
  SEO,
  ReviewCallout,
} from '../components/_index';
import {
  Blob1,
  Blob2,
  Blob3,
  Blob4,
} from '../components/flare/shapes';

const hero = {
  header: 'The "We Buy Houses In Bay Area" Team',
  subheader:
    'In all honesty, I don’t like calling this a company. We are real people, with real feelings and compassion.',
};

const seoContent = {
  title:
    "About · We Buy Houses in Bay Area - [We're #1 For A Reason]",
  description:
    'We Buy Houses in . We are a local home buying company in and we pay cash for houses. "Sell my house without cleaning or repairing or paying closing costs!"',
};

const team = [
  {
    name: 'Eugene Romberg',
    title: ' Owner and Founder',
    profileImg: 'eugeneProfile',
    content:
      'he’s bought and sold over $160 million of real estate since 2015. He lives in San Jose CA with his wife of 7 years and his two boys.',
  },
  {
    name: 'Ray Haikin',
    title: 'Co-Owner',
    profileImg: 'rayProfile',
    content:
      'He has taken part in 50 real estate transaction in the last 4 years. He specializes in remodeling, redevelopment, and marketing. Ray currently resides in Fremont with his wife and kids.',
  },
  {
    name: 'Joseph Mathews',
    title: 'Head of Transaction Coordination and Dispositions',
    profileImg: 'josephProfile',
    content:
      ' has extensive experience in real estate. Joseph loves helping people solve difficult problems. Joseph loves to play soccer and spend time with his family.',
  },
  {
    name: 'Shanti Thomas',
    profileImg: 'shantiProfile',
    title:
      'Senior Escrow Officer at North American Title Company 21060 Redwood Road',
    content:
      'She has been an escrow officer for over 32 years and loves what she does. She is dedicated to make the buying and selling of real estate a seamless process.',
  },
];

const aboutPageContent = [
  {
    // img:

    header: 'Our Values',
    content:
      'Each individual in my team believes that being upfront, genuinely honest and transparent will make life fulfilling and happy. These are the core values I have built my team and myself upon!',
  },
  {
    // img:

    header: 'What We Do',
    content:
      'We are Cash Home Buyers in the Bay Area of California! We rehab and flip houses in the Bay Area of California. We buy houses in the Bay Area from people that no longer want to own it for any reason.',
  },
  {
    // img:

    header: 'How We Work',
    content:
      'We know it is important to give you a great and fair offer, and that is taken very seriously with us. We are not here to take advantage of anyone or waste their time, and we see it as ethically appalling to make an offer based on how desperate you may or may not be able to sell.',
  },
];
const HeroContentBlock = () => (
  <>
    <Heading
      as="h1"
      size="3xl"
      lineHeight="base"
      mb={4}
    >
      <span className="highlight">{hero.header}</span>
    </Heading>
    <Heading
      as="h2"
      variant="sec"
    >
      {hero.subheader}
    </Heading>
  </>
);

const FlareBlock = () => (
  <Box
    zIndex="0"
    height="400px"
    display={{ base: 'none', lg: 'block' }}
  >
    <Box
      className="height-500"
      position="relative"
      width="20rem"
      mx="auto"
      height="15rem"
    >
      <Box
        position="relative"
        mt={4}
      >
        {/* <Box
          position="absolute" top="20%"
          left="20%"
        >
          <GatsbyImage
            className="width-300"
            alt="happy home buyers image"
            image={img}
          />
        </Box> */}
        <Box
          position="absolute"
          top="20%"
          left="20%"
        >
          <FlareGroup7 className="width-500 height-500" />
        </Box>
      </Box>
    </Box>
  </Box>
);

const Pledge = () => (
  <Box
    backgroundColor="gray.200"
    py={20}
  >
    <Container maxW="container.xl">
      <Box
        display="flex"
        flexWrap="wrap"
        py={10}
      >
        <Box
          flexBasis={{ base: '100%', md: '50%' }}
          px={{ base: 0, md: 6 }}
        >
          <Heading size="3xl">
            <span className="highlight">Our Pledge To You</span>
          </Heading>
          <Heading
            variant="sec"
            size="xl"
          >
            We promise to be fair, honest and do whatever it takes to
            come to a win-win transaction.
          </Heading>
          <Link to="/get-offer">
            <Button
              mt={10}
              variant="btnCTA"
              size="lg"
              isLoading={false}
              type="submit"
            >
              Get A Clear Offer!
            </Button>
          </Link>
        </Box>
        <Box
          flexBasis={{ base: '100%', md: '50%' }}
          px={{ base: 0, md: 6 }}
        >
          <Text fontSize="3xl">
            We do not take advantage of others, we firmly believe that
            a person in distress needs someone that can help - and you
            can count on us to be there for you, on your side to the
            end. We do our best to genuinely be the solution to all of
            your real estate hardships. Give us a try - you will see
            how we always manage to exceed expectations.
          </Text>
        </Box>
      </Box>
      <ReviewCallout />
    </Container>
  </Box>
);

const Profile = ({ data, content }) => {
  return (
    <Container maxW="container.xl">
      <Flex
        justifyContent="space-between"
        flexWrap="wrap"
        alignItems="center"
        py="4"
        px="4"
      >
        <Box
          flexBasis={{ sm: '100%', md: '40%' }}
          position="relative"
          px={{ md: 6 }}
        >
          <Box className="width-300">
            <Box
              position="absolute"
              top="-50px"
              left="-20px"
              className="width-400"
              opacity=".3"
            >
              <GatsbyImage
                alt="art flare"
                image={
                  data.ellipseSix.childImageSharp.gatsbyImageData
                }
              />
            </Box>
            <GatsbyImage
              mx="auto"
              alt={`${content.name} profile image`}
              image={
                data[content.profileImg].childImageSharp
                  .gatsbyImageData
              }
            />
          </Box>
        </Box>
        <Box
          rounded="lg"
          py={5}
          backgroundColor="brand.five"
          flexBasis={{ sm: '100%', md: '60%' }}
        >
          <Container>
            <Box my={4}>
              <Heading size="lg">{content.name}</Heading>
              <Heading
                variant="sec"
                size="md"
              >
                {content.title}
              </Heading>
            </Box>
            <Text fontSize="2xl">{content.content}</Text>
          </Container>
        </Box>
      </Flex>
    </Container>
  );
};

const ValuesBlock = ({ data, index }) => {
  const Header = () => (
    <Box
      position="relative"
      zIndex="0"
    >
      <Heading
        size="4xl"
        as="h3"
      >
        {data.header}
      </Heading>

      <Box
        opacity="0.6"
        position="absolute"
        zIndex="-1"
        top={`${-((index + 1) * 20)}%`}
        left={`${-((index + 1) * 10)}%`}
      >
        {' '}
        {index % 2 === 0 ? (
          <Blob1 className="width-300 height-300 fill-6" />
        ) : (
          <Blob2 className="width-400 height-300 fill-7" />
        )}
        <Blob1
          opacity="0.6"
          className="width-300 height-300 fill-2"
        />
      </Box>
    </Box>
  );
  const Content = () => (
    <Box
      position="relative"
      zIndex="0"
    >
      <Box
        position="absolute"
        zIndex="-1"
        opacity="0.6"
        top={`${-((index + 1) * 10)}%`}
        left={`${(index + 1) * 20}%`}
      >
        <Blob3 className="width-300 height-300 fill-3" />
      </Box>
      <Text
        rounded="lg"
        backgroundColor="white"
        p={6}
        fontSize="3xl"
      >
        {data.content}
      </Text>
    </Box>
  );
  return (
    <HalfByHalfSection
      py={4}
      left={<Header />}
      right={<Content />}
    />
  );
};

const AboutPage = ({ data, location }) => {
  return (
    <>
      <SEO
        location={location}
        title={seoContent.title}
        description={seoContent.description}
      />
      <main>
        <Container
          maxW="container.xl"
          mb={10}
        >
          <HalfByHalfSection
            py={{ base: 20, md: 20 }}
            left={<HeroContentBlock />}
            right={<FlareBlock />}
          />

          {team.map((t, i) => (
            <Box
              key={generate()}
              py={10}
              marginTop={{ base: '-200px', md: 'auto' }}
            >
              <Profile
                data={data}
                content={t}
              />
            </Box>
          ))}

          <Pledge />
        </Container>
        <Box backgroundColor="brand.five">
          <Container maxW="container.xl">
            {aboutPageContent.map((el, i) => (
              <ValuesBlock
                key={generate()}
                data={el}
                index={i}
              />
            ))}
          </Container>
          <Container maxW="container.xl">
            <CalloutPhoneNumber />
          </Container>
        </Box>
      </main>
    </>
  );
};

export const query = graphql`
  query {
    eugeneProfile: file(
      relativePath: { eq: "team/eugene-profile.png" }
    ) {
      childImageSharp {
        gatsbyImageData(width: 400, placeholder: BLURRED)
      }
    }
    rayProfile: file(relativePath: { eq: "team/ray-profile.png" }) {
      childImageSharp {
        gatsbyImageData(width: 400, placeholder: BLURRED)
      }
    }
    josephProfile: file(
      relativePath: { eq: "team/joseph-profile.png" }
    ) {
      childImageSharp {
        gatsbyImageData(width: 400, placeholder: BLURRED)
      }
    }
    shantiProfile: file(
      relativePath: { eq: "team/shanti-profile.png" }
    ) {
      childImageSharp {
        gatsbyImageData(width: 400, placeholder: BLURRED)
      }
    }
    ellipseSix: file(
      relativePath: { eq: "illustrations/ellipse-6.png" }
    ) {
      childImageSharp {
        gatsbyImageData(width: 800, placeholder: BLURRED)
      }
    }
    stressFreeImg: file(relativePath: { eq: "ill-group-2.png" }) {
      childImageSharp {
        gatsbyImageData(width: 800, placeholder: BLURRED)
      }
    }
  }
`;

export default AboutPage;
